import { Component, ViewChildren, QueryList, ElementRef, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { Observable } from "rxjs/Observable";
import { Store } from "@ngrx/store";
import * as thresholdActions from '../../../threshold/store/actions/actions';
import { User, Widget, AppState, getUser, getWidgets } from '@api/index';
import { FGWService } from '@threshold/services/fgw.service';

@Component({
	template: require('./dashboard.component.html'),
	styles: [
		`
		.iframe-container {
			position: relative;
		}

		.iframe-container iframe {
			height: 383px;
			width: 100%;
			padding: 15px 15px 0 15px;
		}

		.iframe-widget {
			padding: 0;
		}

		#end-of-ie-support {
			height: auto;
			width: auto;
			background: #2C74B3;
			border-radius: 5px;
			box-shadow: 0 1px 4px 0 rgba(12,12,13,.1);
			margin-bottom: 1rem;
			padding: 10px 10px;
		}

		#end-of-ie-support-heading {
			color: #fff;
			font-weight: 400;
		}

		#end-of-ie-support-cap {
			color: #fff;
			font-size: 1em;
			font-weight: 400;
		}

		#end-of-ie-support-icon {
			margin-right: 10px;
		}

		`
	]
})

export class DashboardComponent implements OnInit {
	@ViewChildren('iframe') iframe: QueryList<ElementRef>;
	public safeURL;
	user$: Observable<User>;
	widgets$: Observable<Widget[]>;

	public frameDomain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v2/#/';
	public componentRoute = 'widget-frame';
	public widgetQuery = 'widgetMode=true';

	public todaysDate;
    public bannerComplex: boolean = true;
    public banners: {
        bannerOne: boolean;
        bannerTwo: boolean;
        bannerThree: boolean;
    } = {
            bannerOne: false,
            bannerTwo: false,
            bannerThree: false,
        };

	public isUnsupportedBrowser: boolean = false;

	/**
	 *
	 * @param store
	 * @param route
	 */
	constructor(
				private fgw: FGWService,
				private sanitizer: DomSanitizer,
				private store: Store<AppState>,
				private route: ActivatedRoute) {

		this.user$ = this.store.select(getUser);
		this.widgets$ = this.store.select(getWidgets);

		// route.data.subscribe((data) => {
		// 	console.log('data' , data.url);
		// 	this.store.dispatch(new ui.LoadDashboardAction(data.url));
		// });

		this.frameDomain = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '') + '/v2/#/';
		this.componentRoute = 'widget-frame';
		this.widgetQuery = 'widgetMode=true';
		this.isUnsupportedBrowser = ((this.ieVersion().IsIE) && (this.ieVersion().CompatibilityMode) && (this.ieVersion().ActingVersion < 11));
	}

	ngOnInit() {
		// this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
		this.initBanner();
	}

	public sanitizerUrl(connectedExperience: string, wName: string): any {
		if (process.env.config.isDevelopment) {
			this.frameDomain = 'http://localhost:4200/#/';
			connectedExperience = 'example-app';
		}
		return this.sanitizer.bypassSecurityTrustResourceUrl(`${this.frameDomain}${this.componentRoute}?${this.widgetQuery}&experienceName=${connectedExperience}&widgetName=${wName}`);
	}

	private initBanner() {

        if (this.fgw.getTheme().indexOf('absa') !== -1) this.bannerComplex = true;
		else this.bannerComplex = false;

        try {
            this.todaysDate = new Date();
            let hour = this.todaysDate.getHours();
            if (hour < 10) this.banners.bannerOne = true;
            else if (hour < 14) this.banners.bannerTwo = true;
            else this.banners.bannerThree = true;
        } catch (e) {
            this.banners.bannerThree = true;
        }
    }

    public loadFrame() {
        // if (this.iframe) {
        //     for (const frame of this.iframe.toArray()) {
        //         setTimeout(() => {
        //             const widgetHiddenClass = '.celine-widget-hidden';
        //             const frameDocument = frame.nativeElement.contentDocument || frame.nativeElement.contentWindow;
        //             const nodeList = frameDocument.querySelectorAll(widgetHiddenClass);
        //             const node = [...nodeList];
        //             if (node.length === 1) {
        //                 frame.nativeElement.parentNode.className = 'd-none';
        //             }
        //         }, 2000);
        //     }
        // }
    }

	public allowExternalNavigation(flag: boolean) {
		// this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(flag));
	}

	onClickLink(path: string) {
        // this.store.dispatch(new thresholdActions.SetAllowExternalNavigationAction(true));
        setTimeout(() => {
            window.location.href = path;
        }, 3000);
    }

	public ieVersion() {
        var value = { IsIE: false, TrueVersion: 0, ActingVersion: 0, CompatibilityMode: false };
        var trident = navigator.userAgent.match(/Trident\/(\d+)/);
        if (trident) {
            value.IsIE = true;
            value.TrueVersion = parseInt(trident[1], 10) + 4;
        }

        var msie = navigator.userAgent.match(/MSIE (\d+)/);
        if (msie) {
            value.IsIE = true;
            value.ActingVersion = parseInt(msie[1]);
        } else value.ActingVersion = value.TrueVersion;


        if (value.IsIE && value.TrueVersion > 0 && value.ActingVersion > 0) value.CompatibilityMode = value.TrueVersion != value.ActingVersion;
        return value;
    }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/angular-router-loader/src!./src/app/celine/components/dashboard/dashboard.component.ts